/* empty css                     */
import e from "./component-library98.js";
const a = {
  name: "GridContainer",
  props: {
    isFluid: { type: Boolean },
    padding: { type: Boolean },
    small: { type: Boolean }
  },
  computed: {
    classes() {
      const i = [];
      return this.isFluid && i.push("grid-container--fluid"), this.padding && i.push("grid-container--padding"), this.small && i.push("grid-container--small"), i;
    }
  }
};
var r = function() {
  var n = this, s = n._self._c;
  return s("div", { staticClass: "grid-container", class: n.classes }, [n._t("default")], 2);
}, t = [], o = /* @__PURE__ */ e(
  a,
  r,
  t,
  !1,
  null,
  "60d6aeba"
);
const c = o.exports;
export {
  c as default
};
